import ApiService from '@/services/api.service'

import type { AxiosResponse } from 'axios'
import type {
  AiResuggestResponse,
  AiSuggestionApplyItem,
  AiSuggestionApplyResponse,
  AiSuggestionsPendingEntity,
  AiSuggestionsResponse,
} from '@/types/services/ai-suggestions'

const base = (entityId: string) => `/api/v1/entities/${entityId}/ai-suggestions`

export default class AiSuggestionsService {
  /** Pending suggestions for the entity, richest position first. */
  static getSuggestions(
    entityId: string
  ): Promise<AxiosResponse<AiSuggestionsResponse>> {
    return ApiService.get(base(entityId))
  }

  /** Across all the user's access, not only the session entity. */
  static getPendingEntities(): Promise<
    AxiosResponse<AiSuggestionsPendingEntity[]>
  > {
    return ApiService.get('/api/v3/accounts/ai_suggestions/pending_entities')
  }

  /** Bulk confirm in one fail-whole transaction. */
  static applySuggestions(
    entityId: string,
    items: AiSuggestionApplyItem[]
  ): Promise<AxiosResponse<AiSuggestionApplyResponse>> {
    return ApiService.put(base(entityId), { items })
  }

  /**
   * Queue a re-classification; returns once queued, not once done. An asset
   * with an unreviewed re-suggest is dropped into `skipped`, so `queued` is
   * the only honest count.
   */
  static resuggest(
    entityId: string,
    assetIds: string[]
  ): Promise<AxiosResponse<AiResuggestResponse>> {
    return ApiService.post(`${base(entityId)}/resuggest`, {
      asset_ids: assetIds,
    })
  }
}
